export default {
  BASE_URL: '/sys/auth',
  api: [
    {
      name: 'list',
      desc: '获取权限树',
      method: 'GET',
      path: 'list'
    },
    {
      name: 'save',
      desc: '设置权限',
      method: 'PUT',
      path: ''
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/system/auth/index.js